module.exports = __webpack_public_path__ + "static/media/brokerContentOne.43da3a3f.png";